module.exports = __webpack_public_path__ + "static/media/AB_S1.0203fe60.jpg";